import React from "react";
import { useSiteSettings } from "../lib/site-settings";

/**
 * Site-wide promo banner. Renders a single eye-catching strip above the
 * marquee announcement bar whenever the admin has enabled
 * `promo_banner_enabled` in site settings.
 *
 * Visual: lime-on-ink with a faint cyan rule. CTA button is gold to draw
 * the eye against the otherwise-cool palette.
 */
export default function PromoBanner() {
  const cfg = useSiteSettings();

  if (!cfg.promo_banner_enabled || !cfg.promo_banner_text) {
    return null;
  }

  const { promo_banner_text, promo_banner_cta_label, promo_banner_cta_url } = cfg;
  const hasCta = promo_banner_cta_label && promo_banner_cta_url;

  return (
    <div
      data-testid="promo-banner"
      className="w-full border-b"
      style={{
        background:
          "linear-gradient(90deg, #06121B 0%, #0E2230 50%, #06121B 100%)",
        borderColor: "rgba(166, 255, 0, 0.18)",
      }}
    >
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4">
        <span
          className="pg-mono text-[11px] uppercase tracking-[0.32em] text-[#A6FF00] font-semibold text-center"
          data-testid="promo-banner-text"
        >
          {promo_banner_text}
        </span>
        {hasCta && (
          <a
            href={promo_banner_cta_url}
            data-testid="promo-banner-cta"
            className="pg-mono text-[10px] uppercase tracking-[0.28em] font-semibold px-3 py-1.5 rounded-sm transition-colors"
            style={{
              backgroundColor: "#A6FF00",
              color: "#0B1220",
            }}
          >
            {promo_banner_cta_label} →
          </a>
        )}
      </div>
    </div>
  );
}
